<div class="custom-slider__container">
  <input
    type="range"
    [min]="min"
    [max]="max"
    [step]="step"
    [value]="value"
    (input)="onInputChange($event)"
    (change)="onSliderChange($event)"
    class="custom-slider"
    [class.is-dragging]="isDragging"
    (mousedown)="onDragStart()"
    (mouseup)="onDragEnd()"
    (touchstart)="onDragStart()"
    (touchend)="onDragEnd()"
    [style.--progress]="progress + '%'"
    [style.--slider-color]="sliderColorVar"
  />

  <span class="custom-slider__tooltip" [style.--progress]="progress">
    {{ valueFormatter(value) }}
  </span>
</div>

@if (showValue) {
  <span class="custom-slider__value">{{ valueFormatter(value) }}</span>
}
